import { create } from 'zustand'
import createSelectors from '../utils/createSelectors'

interface State {
  contact: any
}
interface Action {
  setContact: (contact: State['contact']) => void
  reset: () => void
}

const baseStoreContact = create<State & Action>((set) => ({
  contact: [],
  setContact: (contact) => set(() => ({ contact })),
  reset: () =>
    set({
      contact: []
    })
}))

const useStoreContact = createSelectors(baseStoreContact)

export default useStoreContact
